<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="沟通记录" name="comment" v-if="type!='audit'">
                <div class="comment-list" v-if="commentList.length > 0">
                    <div class="comment-box" v-for="(item,index) in commentList" :key="index">
                        <div class="comment-avatar">
                            <el-avatar shape="square" :size="50" :src="squareUrl"></el-avatar>
                        </div>
                        <div class="comment-detail">
                            <div class="user-box">
                                <span class="username">{{item.user.realname}}</span>
                                <span class="createtime">{{item.create_time}}</span>
                            </div>
                            <div class="info">
                                <div class="info-all">
                                    <div>评论内容：</div>
                                    <div class="info-text">
                                        <template v-if="item.user_list.length > 0">
                                            <el-tag class="approver-item" v-for="(e, index) in item.user_list"
                                                :key="index">
                                                @{{ e.name }}
                                            </el-tag>
                                        </template>
                                        {{item.remark}}
                                    </div>
                                    <div class="demo-image__preview">
                                        <el-image class="img" v-for="(e, index) in item.images" :key="index"
                                            :src="e.url" :preview-src-list="e.srcList"></el-image>
                                    </div>
                                    <div>
                                        <div v-for="(i, index) in item.files" :key="index">
                                            <a class="apply-list" :href="i.url" download="i.name">{{i.name}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-empty v-else description="暂无评论"></el-empty>
            </el-tab-pane>
            <el-tab-pane label="审核流程" name="process">
                <!-- 审核流程 -->
                <div class="confirm-box" v-if="confirmStep.length > 0">
                    <confirm-process :stepList="confirmStep" :confirm="confirm"></confirm-process>
                </div>
            </el-tab-pane>
        </el-tabs>
        <audit-footer-action v-show="showComment" v-if="module_id > 0" :getShow="getShow" ref="auditFooterAction"
            :parent="_self"></audit-footer-action>
    </div>
</template>

<script>
import auditFooterAction from '@/components/comment/footer-action-btn.vue';
import confirmProcess from '@/components/audit/process'; // 新版审核流程
import {
    showDrawerPass
} from '@/utils/common.js';
// 新版本底部按钮

export default {
    provide() {
        return {
            supplier: this,
        }
    },
    props: {
        parent: {},
    }, provide() {
        return {
            supplier: this,
        }
    },
    components: {
        auditFooterAction,
        confirmProcess
    },
    data() {
        return {
            activeName: 'comment',
            squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
            isShow: false,
            commentList: {},
            module: '',
            module_id: 0,
            confirm: {},
            confirmStep: [],
            module_route: '',
            type: "",
            getShow: true,
            showComment: true

        };
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    methods: {
        handleClick(tab, event) {
            if (tab.name == "record") {
                this.isShow = false
            } else {
                this.isShow = false
            }
        },
        // 评论列表
        getComment(module, module_id, type) {
            let _this = this;
            this.module = module;
            this.module_id = module_id;
            this.type = type;
            if (type == "audit") {
                this.activeName = "process";
                if (this.$refs['auditFooterAction']) {
                    this.$refs['auditFooterAction'].getDateList();
                } else {
                    this.$nextTick(() => {
                        this.$refs['auditFooterAction'].getDateList();
                    })
                }
                this.getAuditResult(module_id, '/api/order.audit/getAuditResult') //后端
            }
            if (type == "payment") {
                this.getAuditResult(module_id, '/api/order.audit/getAuditResult') //后端
            }

            if (type == 'fourPlan') {
                _this.getAuditResult(module_id, '/api/plan.four/getAuditResult') //前端
            } else if (type == 'audit') {
                _this.getAuditResult(module_id, '/api/order.audit/getAuditResult') //后端
            } else {
                _this.getAuditResult(module_id, '/api/wedding.four/getAuditResult') //后端
            }

            let url = '/api/comment/index';
            let data = {
                module: _this.module,
                module_id: _this.module_id
            };

            _this.$post(url, data).then((res) => {
                if (res.code == 200) {
                    _this.commentList = res.data.list
                } else {
                    _this.$message.error(res.msg);
                }
            });
        },
        // 获取审核流程 
        getAuditResult(id, getUrl) {

            let _this = this;
            _this.confirmStep = [];
            let url = getUrl;
            let params = {
                id: id,
            };
            _this.$post(url, params).then(res => {
                if (res.code == 200) {
                    let auditProcess = res.data.process;
                    _this.confirmStep = auditProcess

                }
            });
        },
        // 获取审核流程 内部结算流程　外部结算流程　
        getInnerWaiAuditResult(id, type) {
            console.log(id, type)
            let _this = this;
            _this.confirmStep = [];
            let url = '/api/order.audit/getAuditResult';
            let params = {
                id: id,
            };
            _this.$post(url, params).then(res => {
                if (res.code == 200) {
                    if (type == '2') {
                        let auditProcess = res.data.process;
                        let arr = auditProcess.splice(-4, 2);
                        _this.confirmStep = auditProcess
                    }
                    if (type == '1') {
                        let auditProcess = res.data.process;
                        _this.confirmStep = auditProcess.slice(0, auditProcess.length - 2)
                    }

                }
            });
        },

    }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');

.comment-list {
    overflow: hidden;
    width: 100%;
    overflow: auto;
    height: calc(100vh - 200px);

    .comment-box {
        display: flex;
        overflow: auto;
        border-bottom: #f6f0f0 solid 1px;
        padding: 12px 0;

        .comment-avatar {
            flex: 0 50px;
            height: 50px;
            margin-right: 10px;
        }

        .comment-detail {
            flex: 1;
            overflow: hidden;

            .user-box {
                display: flex;
                height: 30px;
                line-height: 30px;
                justify-content: space-between;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                -webkit-justify-content: space-between;

                .username {
                    font-size: 14px;
                    display: inline-block;
                    width: 200px;
                }

                .createtime {
                    font-size: 12px;
                    font-size: 14px;
                    display: inline-block;
                    width: 150px;
                    text-align: right;
                }
            }

            .info {
                display: flex;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                -webkit-justify-content: space-between;
                justify-content: space-between;

                .info-text {
                    padding: 8px 0;
                }

                .info-all {
                    width: 500px;
                    overflow: hidden;

                    .comment-name {
                        color: #409eff;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}

.img {
    width: 100px;
    height: 100px;
    margin-right: 10px;
}

.apply-list {
    padding: 5px 0;
    display: block;
}

.approver-item {
    margin-right: 5px;
    margin-top: 5px;
}
</style>